import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-email-landing',
  templateUrl: './email-landing.component.html',
  styleUrls: ['./email-landing.component.scss']
})
export class EmailLandingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
